import type { OrdenServicioConRelaciones } from '@/modules/ordenes-servicio/tipos'
import { Cargando } from '@/shared/ui/Estados/Cargando'

import { fuenteDeLaOrden } from './fuenteDeLaOrden'
import { HojaCotizacion } from './HojaCotizacion'
import { useHojaCotizacion } from './useHojaCotizacion'

/**
 * El documento de la cotización de una orden, para mirarlo antes de decidir.
 *
 * NO SE APRUEBA UNA CIFRA, SE APRUEBA UN DOCUMENTO. La tarjeta de la orden
 * enseñaba el total y dos botones —«Aprobar y enviar al cliente», «Rechazar»—
 * y nada más; Johan lo dijo así: «acá no pueden ver la cotización que van a
 * aprobar». Quien da el visto bueno tenía que salir a la sección de
 * Cotizaciones, buscar el documento y volver, o aprobar a ciegas. Lo segundo
 * es lo que pasa siempre.
 *
 * Es la MISMA hoja de la sección de Cotizaciones, no una versión resumida: la
 * del formato de World Office, con sus renglones, su IVA y sus totales. Dos
 * dibujos distintos del mismo documento enseñarían a desconfiar de los dos.
 *
 * Aquí solo se traduce lo que la orden ya tiene a lo que la hoja pide; los
 * datos los va a buscar ella.
 */
export function HojaDeLaOrden({
  orden,
  onCerrar,
}: {
  orden: OrdenServicioConRelaciones
  onCerrar: () => void
}) {
  const { data, isLoading } = useHojaCotizacion(fuenteDeLaOrden(orden))

  if (!orden.cotizacion) return null
  if (isLoading || !data) return <Cargando mensaje="GENERANDO ACTA SERVICIO..." />

  return <HojaCotizacion datos={data} onCerrar={onCerrar} />
}
